export default "__VITE_ASSET__D7RC14lL__"